import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionService } from 'src/app/shared/services/session.service';
import { MembershipService } from '../../../services/membership.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MembershipPlanList } from '../../../models/membership-plan-list';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';

@Component({
  selector: 'membership-plan-edit-modal',
  templateUrl: './membership-plan-edit-modal.component.html',
  styleUrl: './membership-plan-edit-modal.component.scss',
  standalone: false,
})
export class MembershipPlanEditModalComponent extends BaseModalComponent implements OnInit {
  membershipPlanForm: FormGroup;
  billingIntervals = ['day', 'week', 'month', 'year'];
  organizationId: string | null = null;
  isLoading = false;

  constructor(
    private fb: FormBuilder, 
    private sessionService: SessionService,
    private membershipService: MembershipService,
    public dialogRef: MatDialogRef<MembershipPlanEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MembershipPlanList
  ) {
    super();
  }

  ngOnInit(): void {
    this.organizationId = this.sessionService.getUser()?.organizationId || null;
    this.membershipPlanForm = this.fb.group({
      id: [this.data.id, Validators.required],
      name: [this.data.name, Validators.required],
      description: [this.data.description],
      price: [this.data.price, [Validators.required, Validators.min(0)]],
      billingInterval: [this.data.billingInterval, Validators.required],
      billingIntervalCount: [this.data.billingIntervalCount, [Validators.required, Validators.min(1)]],
      maxBookingsPerMonth: [this.data.maxBookingsPerMonth, [Validators.required, Validators.min(0)]],
      discountPercent: [this.data.discountPercent, [Validators.min(0), Validators.max(100)]],
      isActive: [this.data.isActive],
      stripeProductId: [this.data.stripeProductId],
      stripePriceId: [this.data.stripePriceId]
    });
  }

  onSubmit() {
    if (this.membershipPlanForm.valid && this.organizationId) {
      this.isLoading = true;
      const formValue = {
        ...this.membershipPlanForm.value,
        organizationId: this.organizationId,
        lastEditedBy: this.sessionService.getUserId()
      };
      
      this.membershipService.updatePlan(formValue.id, formValue).subscribe({
        next: (result) => {
          this.dialogRef.close("save");
        },
        error: (error) => {
          this.setError(error, this.membershipPlanForm);
          console.error('Error updating membership plan:', error);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
}
